import { render, staticRenderFns } from "./DamageTableRow.vue?vue&type=template&id=3cf2063a"
import script from "./DamageTableRow.vue?vue&type=script&lang=ts"
export * from "./DamageTableRow.vue?vue&type=script&lang=ts"
import style0 from "./DamageTableRow.vue?vue&type=style&index=0&id=3cf2063a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports